export default "__VITE_ASSET__o_lrlm_4__"